/**
 * converts String (minutes) into Array with hours and Minutes
 * @param {string} dateIn String
 * @returns {string}
 */
export const convertTime = (dateIn: string): string => {
  if (dateIn) {
    const timeStr = dateIn.split("T")[1];
    const timeArr = timeStr.split(":");
    return `${timeArr[0]}:${timeArr[1]}`;
  }
  return ``;
};
